/**
 * Project Manager workflow walkthrough.
 * @module features/walkthrough/tours/pmTour
 */

import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep } from './navTourHelpers';

const meta = tourMeta('pm-workflow');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const PM_TOUR = {
  id: 'pm-workflow',
  title: meta.title,
  description: meta.description,
  roles: ['pm'],
  prerequisiteRoute: navItemPath('pm-dashboard') ?? '/pm/dashboard',
  priority: 20,
  version: 2,
  visible: (user) => !!user?.isProjectManager,
  steps: [
    navStep('pm-dashboard', {
      title: t('walkthrough.pm.dashboard.title'),
      body: t('walkthrough.pm.dashboard.body'),
    }),
    navStep('review-timesheets', {
      title: t('walkthrough.pm.review.title'),
      body: t('walkthrough.pm.review.body'),
      route: '/pm/review-timesheets',
    }),
    navStep('timesheet-logs', {
      title: t('walkthrough.pm.logs.title'),
      body: t('walkthrough.pm.logs.body'),
    }),
    navStep('pm-download-timesheet', {
      title: t('walkthrough.pm.download.title'),
      body: t('walkthrough.pm.download.body'),
    }),
  ],
};
